import { render, staticRenderFns } from "./ContactLensList.vue?vue&type=template&id=3a22a3ec&scoped=true&"
import script from "./ContactLensList.vue?vue&type=script&lang=js&"
export * from "./ContactLensList.vue?vue&type=script&lang=js&"
import style0 from "./ContactLensList.vue?vue&type=style&index=0&id=3a22a3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22a3ec",
  null
  
)

export default component.exports